// Code review - In Progress
// Documentation - In Progress
import React, { useEffect, useState } from "react";
import { mainTable } from "../css/Common";
import DropDown from "../ReusableComponents/DropDown";
import InputText from "../ReusableComponents/InputText";
import download from "../image/download.png";
import { useUserCapability } from "../components/ConstantReducerProvider";
import { useLocation, useNavigate } from "react-router-dom";
import { IUDAPI, ImageAPI } from "../services/APIConnection";
import FileUpload from "../ReusableComponents/FileUpload";

const UserProfile = ({ data, closePopup }) => {
  const { userProfileState } = useUserCapability();

  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [sdp, setSdp] = useState([]);
  const [location, setLocation] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState(1);
  const [userId, setUserId] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [showImage, setShowImage] = useState("");
  const [showImageError, setShowImageError] = useState("");
  const [imageUploaded, setimageUploaded] = useState("");
  const [designation, setDesignation] = useState("");
  const [roleGroub, setRoleGroup] = useState("");
  const [mstUserId, setMstUserId] = useState("");
  const [bindCountryDD, setBindCountryDD] = useState([
    { value: "1", label: "India" },
    { value: "2", label: "America" },
    { value: "3", label: "Korea" },
  ]);

  const [newImageUploaded, setNewImageUploaded] = useState(false);
  const [disabledBtn, setDisabledBtn] = useState(false);

  const locationData = useLocation();

  useEffect(() => {
    if (Array.isArray(data) && data.length > 0) {
      setMstUserId(data[0].MstUserId);
      setFirstName(data[0].FirstName);
      setMiddleName(data[0].MiddleName);
      setLastName(data[0].LastName);
      setEmail(data[0].UserEmail);
      setPhone(data[0].UserMobile);
      setUserId(data[0].UserId);
      setShowImage(data[0].UserProfileImg);
      setimageUploaded(data[0].UserProfileImg);
      setDesignation(data[0].Designation);
      setRoleGroup(data[0].RoleName);
      setState(data[0].State);
      setLocation(data[0].Location);
      setOrganizationName(data[0].Organization);
    } else {
    }

    if (Object.values(data)) {
      let userSDPs = Object.values(data);

      // Filter out undefined, null, and empty string values
      let sdpData = userSDPs
        .map((items) => items.SDP_en)
        .filter((sdp) => sdp !== undefined && sdp !== null && sdp !== "");

      setSdp(sdpData);
    }
  }, [data]);

  const navigate = useNavigate();
  useEffect(() => {
    var createdBy = sessionStorage.getItem("createdBy");
    if (createdBy == null || createdBy == "") {
      navigate("/");
    }
  }, [navigate, data]);
  const handleShowImage = (showImage) => {
    setShowImage(showImage || "");
    setShowImageError("");
    setNewImageUploaded(true);
  };

  const handleSubmit = async (items, flag) => {
    setDisabledBtn(true);
    if (flag == 2) {
      const userPayload = {
        mstUserId: mstUserId,
        userProfileImg: showImage,
        createdBy: mstUserId,
        flag: flag,
      };

      const response = await IUDAPI(
        userPayload,
        "UserAPI/UpdateUserProfileImage"
      );
      if (response.data.Table[0].Result === "M") {
        data[0].UserProfileImg = showImage;
        setTimeout(() => {
          closePopup(true);
        }, 1000);
        setNewImageUploaded(false);
        setDisabledBtn(false);
      }
    }
  };

  return (
    <div class="w-full">
      <div class="text-xl mx-5 font-medium text-neutral-700 ">
        {"User Profile"}
      </div>
      <div class=" flex flex-col w-full">
        <div class={""}>
          <div className={mainTable.mainContentScreen}>
            <form class="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit  sm:max-h-fit ">
              <div class="grid gap-4 mb-6 md:grid-cols-3">
                <InputText
                  inputType="text"
                  title="First Name"
                  name="firstName"
                  content={firstName}
                  controlFunc={(e) => setFirstName(e.target.value)}
                  disabled="disabled"
                />
                <InputText
                  inputType="text"
                  title="Middle Name"
                  name="middleName"
                  content={middleName}
                  controlFunc={(e) => setMiddleName(e.target.value)}
                  disabled="disabled"
                />
                <InputText
                  inputType="text"
                  title="Last Name"
                  name="lastName"
                  content={lastName}
                  controlFunc={(e) => setLastName(e.target.value)}
                  disabled="disabled"
                />
                <InputText
                  inputType="text"
                  title="Organization"
                  name="lastName"
                  content={organizationName}
                  controlFunc={(e) => setOrganizationName(e.target.value)}
                  disabled="disabled"
                />
                <InputText
                  inputType="email"
                  title="Email"
                  name="email"
                  content={email}
                  controlFunc={(e) => setEmail(e.target.value)}
                  disabled="disabled"
                />
                <InputText
                  inputType="text"
                  title="Mobile Number"
                  name="phone"
                  content={phone}
                  controlFunc={(e) => setPhone(e.target.value)}
                  disabled="disabled"
                />
                <InputText
                  inputType="text"
                  title="Designation"
                  name="userId"
                  content={designation}
                  controlFunc={(e) => setDesignation(e.target.value)}
                  disabled="disabled"
                />
                <InputText
                  inputType="text"
                  title="Role/Groups"
                  name="userId"
                  content={roleGroub}
                  controlFunc={(e) => setRoleGroup(e.target.value)}
                  disabled="disabled"
                />
                <DropDown
                  classDiv="hidden"
                  title="Country"
                  options={bindCountryDD}
                  placeholder="Select"
                  name="country"
                  selectedOption={country}
                  controlFunc={(e) => setCountry(e.target.value)}
                  disabled="disabled"
                />
                {state && (
                  <InputText
                    inputType="text"
                    title="State"
                    name="userId"
                    content={state}
                    controlFunc={(e) => setState(e.target.value)}
                    disabled="disabled"
                  />
                )}
                {location && (
                  <InputText
                    inputType="text"
                    title="City"
                    name="userId"
                    content={location}
                    controlFunc={(e) => setLocation(e.target.value)}
                    disabled="disabled"
                  />
                )}
                {sdp.length > 0 && (
                  <InputText
                    inputType="text"
                    title="S.D.P."
                    name="sdp"
                    content={sdp}
                    disabled="disabled"
                  />
                )}
                <div className="col-span-2">
                  <FileUpload
                    title="Photo"
                    apiCall="UserAPI/UserImageUpload"
                    modalName="UserImage"
                    name="showImage"
                    showImage={showImage}
                     disabledBtn={true}
                    showImageData={handleShowImage}
                    imageUploadedError={showImageError}
                    limitMassage={
                      "Image size limit: 2 MB. Accepted Image types:jpg, png, jpeg."
                    }
                    MAX_FILE_SIZE_MB={2}
                    ALLOWED_FORMATS={["image/jpeg", "image/jpg", "image/png"]}
                  />
                </div>
              </div>
            </form>
            {newImageUploaded && (
              <div class={mainTable.submitCancelMainDiv}>
                <button
                  data-modal-hide="bottom-right-modal"
                  type="button"
                  className={
                    disabledBtn
                      ? mainTable.disabledSubmitButton
                      : mainTable.submitButton
                  }
                  onClick={() => handleSubmit(0, 2)}
                  disabled={disabledBtn}
                >
                  Submit
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
